import { render } from "./securitySetup.vue?vue&type=template&id=d4beaa94"
import script from "./securitySetup.vue?vue&type=script&lang=js"
export * from "./securitySetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__